import { connect } from "react-redux";
import { registerPlugin } from "../common/mapstore/registerPlugin";
import { RootState } from "../rootState";
import { wfsServiceActionCreator } from "../api/api-packages/wfs-service/wfsService.action";
import { FollowGeoBorder, FollowGeoBorderDispatchProps, FollowGeoBorderStateProps } from "./component/FollowGeoBorder";
import { EditAction } from "./redux/types";
import { Feature, FeatureCollection } from "../core/geo/types";
import { EditFeatureOptions } from "./redux";
import { selectFeatureForEditing } from "../common/mapstore/action/draw";
import { saveGeoBordersAction } from "./redux/saveGeoBorders/saveGeoBorders.action";

const mapStateToProps = (state: RootState): FollowGeoBorderStateProps => {
    return {
        isActive: state.editFeature?.options.action === EditAction.FOLLOW_GEO_BORDER,
        editFeature: state.editFeature!,
        bbox: state.map?.present?.bbox,
    };
};

const mapDispatchToProps = (dispatch: any): FollowGeoBorderDispatchProps => {
    return {
        wfsService: (requestParams) => dispatch(wfsServiceActionCreator(requestParams)),
        selectFeatureForEditing: (features: FeatureCollection, options: EditFeatureOptions) =>
            dispatch(selectFeatureForEditing(features, options)),
        saveGeoBorders: (geoBorders: Feature[]) => dispatch(saveGeoBordersAction(geoBorders)),
    };
};

export const ConnectedFollowGeoBorder = connect(mapStateToProps, mapDispatchToProps)(FollowGeoBorder);

export const FollowGeoBorderPlugin = {
    name: "FollowGeoBorderPlugin",
    config: {
        component: ConnectedFollowGeoBorder,
        reducers: {},
        epics: {},
    },
};
export const register = () => registerPlugin(FollowGeoBorderPlugin);
